import {Injectable} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable()
export class FabricCollectionService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getFabricCollectionList(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricCollectionListOption(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricsOfFabricCollection(fabricCollectionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + fabricCollectionId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricByQuery(id, query, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + id + '/fabrics?' + query)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricCollectionItem(FabricCollectionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + FabricCollectionId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getArchivedFabricsOfCollection(FabricCollectionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + FabricCollectionId + '/fabrics')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getAllFabricsOfCollection(FabricCollectionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + FabricCollectionId + '/fabrics')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageFabricCollection(fabricCollection, isEdit, id = null) {
    if (isEdit) {
      delete fabricCollection.fabricCollection.attachedFabrics;
      return this.http.put(environment.apiUrl + '/backoffice/fabric-collection/' + id + '/edit', fabricCollection)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/fabric-collection/', fabricCollection)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteFabricCollection(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/fabric-collection/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public readdFabricCollection(id) {
    return this.http.put(environment.apiUrl + '/backoffice/fabric-collection/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/fabric-collection/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setParentPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/fabric-collection/fabric/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricsByCollectionAndFabricCollection(CollectionId, FabricCollectionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + FabricCollectionId + '/collection/' + CollectionId + '/fabrics')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricByQueryAndCollection(collectionId, id, query, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric-collection/' + id + '/collection/' + collectionId + '/fabrics?' + query)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
